/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';

type M = string | number;
type MessageProps = {
  type: MessageType;
  children: M[] | M;
  hasBackground?: boolean;
};

export const CustomMessage = ({ type, children }: MessageProps) => {
  return <div css={customMessageStyle(type)}>{children}</div>;
};

const customMessageStyle = (type: string) => css`
  font-size: 1.2rem;
  font-weight: 400;
  padding: 0 0.6rem;
  border: 1px solid transparent;
  background-color: ${type === 'website'
    ? 'rgba(82, 196, 26, 1)'
    : type === 'website-mobile'
      ? 'rgba(240, 240, 240, 1)'
      : type === 'app'
        ? 'rgba(24, 144, 255, 1)'
        : 'transparent'};
  color: ${type === 'website'
    ? 'rgba(255, 255, 255, 1)'
    : type === 'website-mobile'
      ? 'rgba(0, 0, 0, 0.45)'
      : type === 'app'
        ? 'rgba(255, 255, 255, 1)'
        : '#000000'};
  text-align: center;
  border-radius: 10rem;
`;
